// LocalDate.js
import React from 'react';

const LocalDate = ({ text, utcDate }) => {
  const date = new Date(utcDate);
  const localDateString = date.toLocaleDateString();
  const localTimeString = date.toLocaleTimeString();
  const textString = text ? text : ""; 
  return `${textString} ${localDateString} ${localTimeString}`;
};
export default LocalDate;
